import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./index.scss";
import img from "../../../assets/images/bg-ai.png";
import img1 from "../../../assets/images/bg-data.png";
import img2 from "../../../assets/images/bg-service.png";
import img3 from "../../../assets/images/bg-management.jpg";
import { IAIcon } from "../../../assets/icons/IAIcon";
import { DataIcon } from "../../../assets/icons/DataIcon";
import { ServiceIcon } from "../../../assets/icons/ServiceIcon";
import { ConseilIcon } from "../../../assets/icons/ConseilIcon";
import { useTranslation } from "react-i18next";

const ExpertiseSection = () => {
  const { t } = useTranslation();

  const domaines = [
    {
      icon: <ConseilIcon />,
      title: t("management_title"),
      text: t("management_text"),
      background: img3,
      position: "start",
    },
    {
      icon: <DataIcon />,
      title: t("data_title"),
      text: t("data_text"),
      background: img1,
      position: "end",
    },
    {
      icon: <IAIcon />,
      title: t("ai_title"),
      text: t("ai_text"),
      background: img,
      position: "start",
    },
   
    {
      icon: <ServiceIcon />,
      title: t("service_title"),
      text: t("service_text"),
      background: img2,
      position: "end",
    },

  ];

  return (
    <section className="expertise-section">
      <Container>
        <h2 className="text-center section-title mb-5">
          {t("expertise_title")} <span>{t("expertise_subtitle")}</span>
        </h2>

        <Row className="g-4 justify-content-center">
          {domaines.map((item, index) => {
            // Special layout for management card (first card)
            if (index === 0 && item.background === img3) {
              return (
                <Col key={index} xs={12} md={12} lg={10}>
                  <Card className="expertise-card management-card h-100 p-0">
                    <Row className="g-0 h-100">
                      <Col xs={12} md={6} className="order-1 order-md-1">
                        <Card.Body className="d-flex flex-column justify-content-center h-100">
                          <div className="d-flex gap-3 align-items-center">
                            <div className="icon">{item.icon}</div>
                            <h5 className="m-0">{item.title}</h5>
                          </div>
                          <Card.Text className="mt-3">{item.text}</Card.Text>
                        </Card.Body>
                      </Col>
                      <Col xs={12} md={6} className="order-2 order-md-2">
                        <div className="management-image-wrapper h-100">
                          <img
                            src={item.background}
                            alt={item.title}
                            className="management-image"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              );
            }

            // Special layout for service card (centre de services)
            if (item.background === img2) {
              return (
                <Col key={index} xs={12} md={12} lg={10}>
                  <Card className="expertise-card management-card h-100 p-0">
                    <Row className="g-0 h-100">
                      <Col xs={12} md={6} className="order-1 order-md-1">
                        <Card.Body className="d-flex flex-column justify-content-center h-100">
                          <div className="d-flex gap-3 align-items-center">
                            <div className="icon">{item.icon}</div>
                            <h5 className="m-0">{item.title}</h5>
                          </div>
                          <Card.Text className="mt-3">{item.text}</Card.Text>
                        </Card.Body>
                      </Col>
                      <Col xs={12} md={6} className="order-2 order-md-2">
                        <div className="management-image-wrapper h-100">
                          <img
                            src={item.background}
                            alt={item.title}
                            className="management-image"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              );
            }
            
            // Default layout for other cards
            return (
              <Col key={index} md={6} lg={5}>
                <Card
                  className="expertise-card h-100 p-0 p-md-3"
                  style={{
                    backgroundImage: `url(${item.background})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}>
                  <Card.Body>
                    <div
                      className={`d-flex flex-column justify-content-${item.position} h-100`}>
                      <div className="d-flex gap-3 align-items-center">
                        <div className="icon">{item.icon}</div>
                        <h5 className="m-0">{item.title}</h5>
                      </div>
                      <Card.Text className="mt-3">{item.text}</Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default ExpertiseSection;
